<template>
  <div class="popup-full  _new-design  modal-after-respond-without-resume">
    <div class="popup-full__wrap">

      <button type="button"
              @click.prevent="onClose"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__main">
            <div class="popup-full__media">
              <picture class="popup-full__img">
                <img src="../assets/img/popup/after-respond-without-resume.svg"
                     :alt="$tVacancy('Congratulations!')">
              </picture>
            </div>

            <h3 class="popup-full__title">{{ $tLegalServices('modal_open_legal_services_chat_bot_title') }}</h3>
            <div class="popup-full__text text">
              <p>{{
                  $tLegalServices('modal_open_legal_services_chat_bot_description')
                }}</p>
            </div>

            <div class="modal-after-respond-without-resume__soc-bot-wrap">
              <div class="modal-after-respond-without-resume__soc-bot-list">
                <template v-for="messenger in messengers">
                  <a v-if="urlsComputed[messenger]"
                     :key="messenger"
                     :href="urlsComputed[messenger]"
                     target="_blank"
                     @click="onRespond(messenger)"
                     :class="'_' + messenger"
                     class="modal-after-respond-without-resume__soc-bot-item">
                    <BaseSvg :name="`ico-${messenger}`"/>
                  </a>
                  <div v-else
                       :key="messenger"
                       :class="'_' + messenger"
                       class="modal-after-respond-without-resume__soc-bot-item  _disabled">
                    <BaseSvg :name="`ico-${messenger}`"/>
                  </div>
                </template>
              </div>
            </div>

            <BaseAlert :value="error"
                       class="modal-after-respond-without-resume__error  _error"/>

            <BasePreloader v-if="pending"/>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import handleError from '@/helpers/handleError'

  export default {
    name: 'ModalOpenLegalServicesChatBox',
    props: {
      botUrls: {
        type: Object
      },
    },
    data() {
      return {
        pending: false,
        error: null,
        messengers: [
          'viber',
          'telegram',
          'messenger',
        ]
      }
    },
    computed: {
      urlsComputed() {
        return this.botUrls
      }
    },
    methods: {
      onClose() {
        this.$vModal.close('open-legal-services-chat-bot')
      },
      onRespond(messenger) {
        this.pending = true

        http.post('/api/services/legal/order', {
          messenger
        }).then(() => {
          this.$router.push({name: 'legal-services-request-sent'})
          this.onClose()
        }).catch((error) => {
          this.error = handleError(error)
        }).finally(() => {
          this.pending = false
        })
      }
    }
  }
</script>

<style lang="less">

</style>
